import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b2306f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: /*#__PURE__*/ _normalizeClass(`paralax_images`)
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = { class: "paralax_images__images d-flex" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "plyr plyr--full-ui plyr--video plyr--html5 plyr--fullscreen-enabled plyr--pip-supported plyr--playing plyr--hide-controls paralax_images__images--one img-fluid"
};
const _hoisted_7 = {
    autoplay: "",
    playsinline: "",
    loop: ""
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
    key: 3,
    class: "plyr plyr--full-ui plyr--video plyr--html5 plyr--fullscreen-enabled plyr--pip-supported plyr--playing plyr--hide-controls paralax_images__images--two img-fluid"
};
const _hoisted_11 = {
    autoplay: "",
    playsinline: "",
    loop: ""
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    key: 5,
    class: "plyr plyr--full-ui plyr--video plyr--html5 plyr--fullscreen-enabled plyr--pip-supported plyr--playing plyr--hide-controls paralax_images__images--three img-fluid"
};
const _hoisted_15 = {
    autoplay: "",
    playsinline: "",
    loop: ""
};
const _hoisted_16 = ["src"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'parallax_images',
    props: ['d'],
    setup(__props) {
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        return (_ctx, _cache) => {
            const _directive_prlx = _resolveDirective("prlx");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["inner", { 'container': isMobile.value }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                (!__props.d.video_one)
                                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "paralax_images__images--one img-fluid",
                                        src: __props.d.image_one,
                                        loading: "lazy"
                                    }, null, 8, _hoisted_5)), [
                                        [_directive_prlx, { reverse: true, fromBottom: true, disabled: isMobile.value }]
                                    ])
                                    : _createCommentVNode("", true),
                                (__props.d.video_one)
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("video", _hoisted_7, [
                                            _createElementVNode("source", {
                                                src: __props.d.video_one,
                                                type: "video/mp4"
                                            }, null, 8, _hoisted_8)
                                        ])
                                    ])), [
                                        [_directive_prlx, { reverse: true, fromBottom: true, disabled: isMobile.value }]
                                    ])
                                    : _createCommentVNode("", true),
                                (!__props.d.video_two)
                                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        class: "paralax_images__images--two img-fluid",
                                        src: __props.d.image_two,
                                        loading: "lazy"
                                    }, null, 8, _hoisted_9)), [
                                        [_directive_prlx, { speed: 0.5, reverse: true, fromBottom: true, disabled: isMobile.value }]
                                    ])
                                    : _createCommentVNode("", true),
                                (__props.d.video_two)
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("video", _hoisted_11, [
                                            _createElementVNode("source", {
                                                src: __props.d.video_two,
                                                type: "video/mp4"
                                            }, null, 8, _hoisted_12)
                                        ])
                                    ])), [
                                        [_directive_prlx, { speed: 0.5, reverse: true, fromBottom: true, disabled: isMobile.value }]
                                    ])
                                    : _createCommentVNode("", true),
                                (!__props.d.video_three)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 4,
                                        class: "paralax_images__images--three img-fluid",
                                        src: __props.d.image_three,
                                        loading: "lazy"
                                    }, null, 8, _hoisted_13))
                                    : _createCommentVNode("", true),
                                (__props.d.video_three)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("video", _hoisted_15, [
                                            _createElementVNode("source", {
                                                src: __props.d.video_three,
                                                type: "video/mp4"
                                            }, null, 8, _hoisted_16)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ], 2)
            ]));
        };
    }
});
